import React from 'react';
import { RefreshCw, AlertTriangle } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/landing';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div 
          className="min-h-screen flex flex-col items-center justify-center px-6"
          style={{ backgroundColor: '#FAF9F6', fontFamily: 'Outfit, sans-serif' }}
        >
          <div className="text-center max-w-sm">
            {/* Icon */}
            <div 
              className="w-16 h-16 mx-auto mb-6 flex items-center justify-center"
              style={{ backgroundColor: 'rgba(212, 175, 55, 0.1)' }}
            >
              <AlertTriangle className="w-8 h-8" style={{ color: '#D4AF37' }} strokeWidth={1.5} />
            </div>

            {/* Title */}
            <h1 
              className="text-2xl mb-3"
              style={{ fontFamily: 'Playfair Display, serif', color: '#0F0F0F' }}
            >
              Something went wrong
            </h1>

            {/* Description */}
            <p className="text-sm mb-8" style={{ color: '#595959' }}>
              We're sorry, but something unexpected happened. Please try reloading the page.
            </p>

            {/* Actions */}
            <div className="space-y-3">
              <button
                onClick={this.handleReload}
                className="w-full py-4 text-white text-sm tracking-[0.1em] uppercase flex items-center justify-center gap-3"
                style={{ background: 'linear-gradient(135deg, #E5B2B9 0%, #D4AF37 100%)', fontWeight: 500 }}
              >
                <RefreshCw className="w-5 h-5" strokeWidth={1.5} />
                Reload Page
              </button>

              <button
                onClick={this.handleGoHome}
                className="w-full py-4 text-sm tracking-[0.1em] uppercase"
                style={{ backgroundColor: '#0F0F0F', color: '#FFFFFF', fontWeight: 500 }}
              >
                Go to Home
              </button>
            </div>

            {/* Debug Info (only in development) */}
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="mt-8 p-4 text-left bg-white border" style={{ borderColor: '#E5E5E5' }}>
                <p className="text-xs font-mono" style={{ color: '#991B1B' }}>
                  {this.state.error.toString()}
                </p>
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
